import {useState} from "react";

export const UseForm = (definition = {}) => {
    const [formState, setFormState] = useState(definition)

    const onInputChange = ({target}) => {
        const {name, value} = target
        setFormState({...formState, [name]: value})
    }

    const onReset = () => {
        setFormState(definition)
    }

    return {
        formState,
        onInputChange,
        onReset
    }
}